<p-confirmDialog key="batch1" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="batch2" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Instructions-->
<div class="ItemBorder">
	<h4 style="text-align: center">Instructions:</h4>

	<div class="AlignCenter">
		<ul>
			<li>
				<p class="InstructionText">Import a text or csv file then press batch email them to email a registration code.</p>
			</li>
			<li>
				<p class="InstructionText">Import Format: Staff ID, Staff Email</p>
			</li>
			<li>
				<p class="InstructionText">NOTE: It might be easier to press export, get a file, make your changes to it, and then re-import that file.</p>
			</li>
		</ul>
	</div>
</div>

<!--Buttons-->
<div class="ButtonMenu TopMargin">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onImport()">Import</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary LeftMargin" (click)="onClearImportData()">Clear Import Data</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary LeftMargin" (click)="onDownloadImportTable()">Download Import Table</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary LeftMargin" (click)="onExport()">Export</button>
	<button [disabled]="IsLoading() == true" class="btn btn-success LeftMargin" (click)="onBatchEmail()">Batch Email</button>
</div>

<!--Imported Data-->
<div class="TopMarinExtra">
	<p-accordion>
		<p-accordionTab
			header="Imported Data {{ ImportPreviewExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="ImportPreviewExpand"
		>
			<div>
				<caass-staff-digital-id-batch-import-table [Processing]="Processing"> </caass-staff-digital-id-batch-import-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>
